import { useToasterContext } from '../Toaster.context';

export const useToastNotification = () => useToasterContext();
